import {createRoot, hydrateRoot} from 'react-dom/client';
import SingleSiteTemplate from '../pages/SingleSiteTemplate/SingleSiteTemplate'
import "../index.css";
import "../pages/SingleSiteTemplate/SingleSiteTemplate.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SingleSiteTemplate {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SingleSiteTemplate {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SingleSiteTemplateVC = {mount, hydrate, unmount}